import React, { RefObject } from 'react';
import { ButtonWithDropdownTemplate } from './ButtonWithDropdownTemplate';
import { DropdownButton } from './DropdownButton';
import { CommonButtonWithDropdownProps } from './types';

export const ButtonWithDropdown = ({
  options,
  children,
  footerContent,
  headerContent,
  isKeepOpen = false,
  isDisabled = false,
  alignMenuTo = 'left',
  dropdownStyle,
  iconStyle,
  tooltipText,
  hideChevron,
  disablePortal,
  dropdownSize,
  minDropdownSize,
  maxDropdownSize,
  maxDropdownHeight,
  iconName,
  iconSize,
  onMenuOpen,
  onMenuClose,
  clickNamespace,
  isActive,
  requestOpen,
  onClick,
  isOpen: externallyManagedIsOpen,
  modalBoxVerticalOffset,
  renderDropdownButton,
  ...props
}: CommonButtonWithDropdownProps) => (
  <ButtonWithDropdownTemplate
    renderButton={
      renderDropdownButton
        ? renderDropdownButton
        : (
            hostRef: RefObject<HTMLElement | null>,
            isOpen: boolean,
            openModal: VoidFunction
          ) => (
            <DropdownButton
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                onClick?.();
                return options.length
                  ? openModal()
                  : undefined; /* don't show an empty dropdown with 0 options. */
              }}
              hostRef={hostRef}
              isActive={isActive}
              isDisabled={isDisabled}
              iconName={iconName}
              iconSize={iconSize}
              hideChevron={hideChevron}
              isOpen={externallyManagedIsOpen ?? isOpen}
              tooltipText={tooltipText}
              {...props}
            >
              {children}
            </DropdownButton>
          )
    }
    options={options}
    footerContent={footerContent}
    headerContent={headerContent}
    isKeepOpen={isKeepOpen}
    alignMenuTo={alignMenuTo}
    dropdownStyle={dropdownStyle}
    iconStyle={iconStyle}
    disablePortal={disablePortal}
    dropdownSize={dropdownSize}
    minDropdownSize={minDropdownSize}
    maxDropdownSize={maxDropdownSize}
    maxDropdownHeight={maxDropdownHeight}
    onMenuOpen={onMenuOpen}
    onMenuClose={onMenuClose}
    clickNamespace={clickNamespace}
    requestOpen={requestOpen}
    isOpen={externallyManagedIsOpen}
    modalBoxVerticalOffset={modalBoxVerticalOffset}
  />
);
